import type {Condition} from '../../types/rules-types'
import type {PropertyValue} from '@github-ui/custom-properties-types'
import type {PickerRepository} from '@github-ui/repos-picker'
import {useCreatePropertyBanner} from './use-create-property-banner'
import {NudgeBanner} from './NudgeBanner'
import {SuccessBanner} from './SuccessBanner'

interface Props {
  className?: string
  condition: Condition
  sourceName: string
  selectedRepos: PickerRepository[]
  onSuccess(propertyName: string, appliedValue: PropertyValue, selectedReposCount: number): void
}

export function CreatePropertyBanner({className, condition, sourceName, selectedRepos, onSuccess}: Props) {
  const {banner, notifyPropertyCreated} = useCreatePropertyBanner({condition})

  switch (banner.kind) {
    case 'success':
      return (
        <div className={className}>
          <SuccessBanner
            sourceName={sourceName}
            propertyName={banner.createdProperty.propertyName}
            repositoryCount={banner.createdProperty.repositoryCount}
          />
        </div>
      )
    case 'nudge':
      return (
        <div className={className}>
          <NudgeBanner
            repositories={selectedRepos}
            sourceName={sourceName}
            onPropertyCreated={(propertyName, appliedValue) => {
              notifyPropertyCreated({propertyName, repositoryCount: selectedRepos.length})
              onSuccess(propertyName, appliedValue, selectedRepos.length)
            }}
          />
        </div>
      )
    case 'none':
      return null
  }
}
